import {Component, OnInit, inject, signal} from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HeaderComponent} from "../../../common/header/header.component";

import {LocaleService} from "../../../../locale/locale.service";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';
import {ClaimsService} from "../../../../services/claims.service";
import {WhoIsAtFault} from "../../../../enums/who-is-at-fault";
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-fault-allocation',
  imports: [
    FooterComponent,
    FormsModule,
    HeaderComponent,
    ReactiveFormsModule,
    NgOptimizedImage
  ],
  templateUrl: './fault-allocation.component.html',
  styleUrl: './fault-allocation.component.css'
})
export class FaultAllocationComponent implements OnInit {
  locale = inject(LocaleService);
  private formNavigationService = inject(FormNavigationService);
  private claimService = inject(ClaimsService);

  showError: boolean = false;
  options: { headline: string, caption: string, value: string }[] = [];
  radioControl = new FormControl();
  showAdditionalInformation = signal(false);

  ngOnInit(): void {
    this.options = [
      {
        headline: this.locale.currentTranslation.faultAllocationOptionHeadline1,
        caption: "",
        value: WhoIsAtFault.Both
      },
      {
        headline: this.claimService.isDriver() ? this.locale.currentTranslation.faultAllocationOptionHeadline2 : this.locale.currentTranslation.thirdPartyFaultAllocationOptionHeadline2,
        caption: "",
        value: WhoIsAtFault.ThirdParty
      },
      {
        headline: this.claimService.isDriver() ? this.locale.currentTranslation.faultAllocationOptionHeadline3 : this.locale.currentTranslation.thirdPartyFaultAllocationOptionHeadline3,
        caption: "",
        value: WhoIsAtFault.FirstParty
      },
      {
        headline: this.locale.currentTranslation.faultAllocationOptionHeadline4,
        caption: "",
        value: WhoIsAtFault.Unknown
      },
    ];
    this.claimService.getData().subscribe(() => {
      if (this.claimService.claimReport()?.fault) {
        this.radioControl = new FormControl(this.claimService.claimReport().fault);
      }
    })
  }

  nextClicked() {
    this.evaluateShowError()
    if (!this.showError) {
      this.claimService.updateClaimReport({fault: this.radioControl.getRawValue()});
      this.claimService.save().subscribe(() => {
        this.formNavigationService.navigate(NavigationKey['fault-allocation']);
      });
    }
  }

  private evaluateShowError() {
    let rawValue = this.radioControl.getRawValue();
    this.showError = rawValue == null;
  }

  setOption(value: string) {
    this.radioControl.patchValue(value);
    this.showError = false
  }

  triggerHint() {
    this.showAdditionalInformation.update(value => !value);
  }
}
